import { getPlatform } from './platform.js';

// CloudStorage is flaky on these platforms; fall back to localStorage. Note
// this set is a superset of webPlatforms — macOS native also has CloudStorage
// issues but doesn't have the confirm-popup issue.
const flakyPlatforms = ["web", "weba", "webk", "unknown", "macos"];

export function safeGetItem(key, timeoutMs = 3000) {
	return new Promise((resolve) => {
		const platform = getPlatform();

		if (flakyPlatforms.includes(platform)) {
			console.log(`[DEV] Platform '${platform}' detected. Bypassing CloudStorage -> LocalStorage.`);
			const val = localStorage.getItem("tg_mock_" + key);
			return resolve(val || null);
		}

		let isSettled = false;

		const timer = setTimeout(() => {
			if (!isSettled) {
				isSettled = true;
				console.warn(`⚠️ Telegram CloudStorage timed out for key: ${key}`);
				resolve(null);
			}
		}, timeoutMs);

		try {
			if (!window.Telegram?.WebApp?.CloudStorage) {
				throw new Error("CloudStorage API missing on native platform");
			}

			window.Telegram.WebApp.CloudStorage.getItem(key, (err, val) => {
				if (isSettled) return;
				isSettled = true;
				clearTimeout(timer);

				if (err) {
					console.error("Telegram Storage Error:", err);
					resolve(null);
				} else {
					resolve(val || null);
				}
			});
		} catch (e) {
			if (!isSettled) {
				isSettled = true;
				clearTimeout(timer);
				console.error("Critical CloudStorage Crash:", e);
				resolve(null);
			}
		}
	});
}

export function safeSetItem(key, value) {
	return new Promise((resolve) => {
		const platform = getPlatform();

		if (flakyPlatforms.includes(platform)) {
			console.log(`[DEV] Platform '${platform}' detected. Bypassing CloudStorage -> LocalStorage.`);
			localStorage.setItem("tg_mock_" + key, value);
			return resolve(true);
		}

		try {
			if (!window.Telegram?.WebApp?.CloudStorage) {
				throw new Error("CloudStorage API missing on native platform");
			}

			window.Telegram.WebApp.CloudStorage.setItem(key, value, (err, isStored) => {
				if (err) {
					console.error("Telegram Storage Error:", err);
					resolve(false);
				} else {
					resolve(true);
				}
			});
		} catch (e) {
			console.error("Critical CloudStorage Crash:", e);
			resolve(false);
		}
	});
}

export function safeRemoveItem(key) {
	return new Promise((resolve) => {
		try {
			localStorage.removeItem("tg_mock_" + key);
		} catch (_) {}

		const platform = getPlatform();
		if (flakyPlatforms.includes(platform)) {
			return resolve(true);
		}

		try {
			if (!window.Telegram?.WebApp?.CloudStorage) {
				return resolve(true);
			}

			window.Telegram.WebApp.CloudStorage.removeItem(key, (err) => {
				if (err) {
					console.error("Telegram Storage Remove Error:", err);
					resolve(false);
				} else {
					resolve(true);
				}
			});
		} catch (e) {
			console.error("Critical CloudStorage Remove Crash:", e);
			resolve(false);
		}
	});
}